export interface SectionSpecUpload {
	uploadFileId: number;
	fileName: string;
}

export const SECTION_SPEC_MEDIA_TYPE = {
	PDF: "application/pdf",
} as const;

const PDF_FILE_EXTENSION = /\.pdf$/i;

export const isSectionSpecPdf = (
	fileName: string | null,
	mediaType?: string,
): boolean =>
	mediaType?.toLowerCase() === SECTION_SPEC_MEDIA_TYPE.PDF ||
	(fileName !== null && PDF_FILE_EXTENSION.test(fileName));
